import { gql } from '@apollo/client';

export const IV_APPLICATION_COMMENT = gql`
  query IVGetApplicationComments($applicationId: String!) {
    vm {
      application(applicationId: $applicationId) {
        comments {
          commentId
          parentId
          content
          submittedDate
          removedDate
          attachments {
            attachmentId
            fileType
            url
            name
          }
          volunteer {
            volunteerId
            profile {
              preferredName
              lastName
              avatarUrl
            }
          }
          reactions {
            reactionId
            emoji
            volunteer {
              volunteerId
            }
          }
        }
      }
    }
  }
`;

export const IV_COMBINED_COMMENT = gql`
  query IVGetCombinedComments($applicationId: String!, $profileId: String!) {
    vm {
      profile(profileId: $profileId) {
        comments {
          commentId
          parentId
          content
          submittedDate
          removedDate
          attachments {
            attachmentId
            fileType
            url
            name
          }
          volunteer {
            volunteerId
            profile {
              preferredName
              lastName
              avatarUrl
            }
          }
          reactions {
            reactionId
            emoji
            volunteer {
              volunteerId
            }
          }
        }
      }
      application(applicationId: $applicationId) {
        comments {
          commentId
          parentId
          content
          submittedDate
          removedDate
          attachments {
            attachmentId
            fileType
            url
            name
          }
          volunteer {
            volunteerId
            profile {
              preferredName
              lastName
              avatarUrl
            }
          }
          reactions {
            reactionId
            emoji
            volunteer {
              volunteerId
            }
          }
        }
      }
    }
  }
`;
